import { CampaignStatistics } from '@hprofits/api';
import { campaignKeys, useCampaignStatistics } from '@hprofits/api-client';
import { useQueryClient } from '@tanstack/vue-query';

import { apiClient } from '@/api-client';
import { CampaignGroupParams } from '@/modules/campaigns/composables/context/types';
import { toErrorRef } from '@/modules/common/state/toErrorRef';
import { DataSource } from '@/modules/common/state/types';
import { useQueryDataSource } from '@/modules/common/state/useQueryDataSource';

export const useCampaignStatisticsDataSource = ({
  campaignGroupId,
}: CampaignGroupParams): DataSource<CampaignStatistics> => {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useCampaignStatistics(apiClient, { campaignId: campaignGroupId });

  const invalidate = () => {
    return queryClient.invalidateQueries({
      queryKey: campaignKeys.statistics(campaignGroupId),
    });
  };

  return useQueryDataSource({
    query: {
      data,
      isLoading,
      error: toErrorRef(error),
      refetch: invalidate,
    },
  });
};
